import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getRasaUrl, putRasaUrl } from '../../../api/urls'
import useApiCall from '../../../api/useApiCall'
import { ReactComponent as Pencil } from '../../../assets/icons/pencil.svg'

import EditUrl from './EditUrl/EditUrl'

import styles from './urls.module.scss'

function Urls() {
    const { t } = useTranslation()

    const [rasaUrl, setRasaUrl] = useState('')

    useApiCall(getRasaUrl, setRasaUrl)

    const [isResourcesUrlEditing, setIsRasaUrlEditing] = useState(false)

    const handleSubmitResourcesUrl = (newUrl: string) => {
        putRasaUrl(newUrl)
        setRasaUrl(newUrl)
        setIsRasaUrlEditing(false)
    }

    return (
        <main className={styles.urls}>
            <div className={styles.urls__head}>{t('urls')}</div>
            <div className={styles.urls__content}>
                <div className={styles.urls__url}>
                    RasaUrl:
                    {isResourcesUrlEditing ? (
                        <EditUrl
                            url={rasaUrl}
                            handleSubmit={handleSubmitResourcesUrl}
                        />
                    ) : (
                        <>
                            <div>{rasaUrl}</div>
                            <button
                                className={styles.urls__urlBtn}
                                onClick={() => setIsRasaUrlEditing(true)}
                            >
                                <Pencil className={styles.urls__urlIcon} />
                            </button>
                        </>
                    )}
                </div>
            </div>
        </main>
    )
}

export default Urls
